import { SOURCE_TYPE_NAMES } from "@/constants/sourceTypeIcon";
import { Avatar, Tooltip } from "antd";
import classNames from "classnames";
import Link from "next/link";
import HBIcon from "../HBIcon";
import styles from "./index.module.less";

export default function FollowerAvatar({
  className,
  iconClassName,
  size,
  src,
  icon,
  style,
  alt,
  href,
  onClick,
  children,
  sourceId,
  sourceType,
}) {
  // 一像素透明图片 https://png-pixel.com/
  const imgReplacer =
    "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";

  return (
    <div
      className={classNames([styles.avatar, className])}
      style={{ width: size + "px", height: size + "px", ...style }}
      onClick={() => {
        onClick && onClick();
      }}
    >
      {children || (
        <Avatar
          size={size}
          src={src || imgReplacer}
          style={{
            backgroundColor: src ? "rgba(0, 0, 0, 0.02)" : "#505153",
            fontSize: size * 0.6 + "px",
          }}
        >
          {alt}
        </Avatar>
      )}

      {icon && (
        <span
          className={classNames(styles.icon, iconClassName)}
          style={{
            width: Math.floor(size * 0.4) + "px",
            height: Math.floor(size * 0.4) + "px",
          }}
        >
          <HBIcon type={icon} />
        </span>
      )}

      {href && (
        <Link href={href}>
          <a
            target="_blank"
            className={styles.icon_link}
            style={{
              width: Math.round(size * 0.4) + "px",
              height: Math.round(size * 0.4) + "px",
            }}
            data-gd-click="button_click"
            data-button-name="访问详情页点击"
            data-concern-object-type={SOURCE_TYPE_NAMES[sourceType]}
            data-concern-object-id={sourceId}
            data-concern-object-name={alt}
          >
            <Tooltip
              placement="bottom"
              target="hover"
              title={`访问${SOURCE_TYPE_NAMES[sourceType]}详情页`}
            >
              <HBIcon
                style={{ transform: "rotateZ(180deg)" }}
                type={"ic_arrowThinLeft"}
              />
            </Tooltip>
          </a>
        </Link>
      )}
    </div>
  );
}
